<template>
  <section id="news" class="h25-section alt">
    <div class="h25-container">
      <div class="h25-sec-hd center">
        <div class="label">News</div><h2>公司动态</h2>
        <p>记录创势互联成长历程中的每一个重要时刻</p>
      </div>
      <div class="news-grid">
        <div class="news-card" v-for="item in newsList" :key="item.id" @click="openDetail(item)">
          <div class="news-img">
            <img v-if="item.coverImg" :src="item.coverImg" :alt="item.title" @error="item.coverImg=''" />
            <span v-if="!item.coverImg" class="ph">{{ item.title }}</span>
          </div>
          <div class="news-info">
            <div class="news-date">{{ item.publishDate }}</div>
            <h5>{{ item.title }}</h5>
            <p>{{ item.content }}</p>
            <span class="news-detail-btn">查看详情</span>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import axios from 'axios'
import { ImgUrl } from '@/unitils/doMain'
export default {
  name:'NewsSection',
  inject:['showNewsDetail'],
  data(){return{newsList:[]}},
  mounted(){this.fetchNews()},
  methods:{
    fetchNews(){
      axios.get('/api/csWeb/articles?categories=公司动态&orderBy=publishDate desc').then(res=>{
        const list=(res.data.list||[]).map(item=>({
          ...item,
          coverImg:item.imgs?ImgUrl+item.imgs.split(':')[0]:''
        }))
          console.log(list, '公司动态')
        list.sort((a,b)=>new Date(b.publishDate)-new Date(a.publishDate))
        this.newsList=list.slice(0,6)
      }).catch(()=>{})
    },
    openDetail(item){ this.showNewsDetail(item) }
  }
}
</script>
<style scoped>
.news-grid{display:grid;grid-template-columns:repeat(auto-fit,minmax(360px,1fr));gap:18px}
.news-card{background:var(--h25-white);border:1px solid var(--h25-border);border-radius:var(--h25-radius);overflow:hidden;transition:border-color .2s;display:flex;flex-direction:column;cursor:pointer}
.news-card:hover{border-color:var(--h25-muted2)}
.news-img{width:100%;height:180px;background:var(--h25-bg);display:flex;align-items:center;justify-content:center;overflow:hidden;flex-shrink:0}
.news-img img{width:100%;height:100%;object-fit:cover}
.ph{font-size:13px;color:var(--h25-muted2);text-align:center;padding:20px;line-height:1.6}
.news-info{padding:20px 22px;flex:1;display:flex;flex-direction:column}
.news-date{font-size:11px;color:var(--h25-accent);margin-bottom:8px;font-weight:600;text-transform:uppercase;letter-spacing:1px}
.news-info h5{font-size:15px;font-weight:700;color:var(--h25-text);margin-bottom:8px;line-height:1.4}
.news-info p{font-size:13px;color:var(--h25-muted);line-height:1.8;flex:1;overflow:hidden;display:-webkit-box;-webkit-line-clamp:3;-webkit-box-orient:vertical}
.news-detail-btn{display:inline-block;margin-top:14px;padding:8px 20px;background:transparent;color:var(--h25-accent);border:1px solid var(--h25-accent);border-radius:20px;font-size:12px;font-weight:600;cursor:pointer;text-align:center;transition:all .2s;align-self:flex-end}
.news-detail-btn:hover{background:var(--h25-accent);color:var(--h25-white)}
</style>
